import Vue from 'vue';
import App from './App.vue';
import Meta from 'vue-meta';
import router from './router';
import store from './store/store';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import * as VueGoogleMaps from 'vue2-google-maps';
// import VueAnalytics from 'vue-analytics';
import VueGtag from 'vue-gtag';
import VueSocialSharing from 'vue-social-sharing';

import {
  VUE_APP_GOOGLE_API_KEY,
  VUE_APP_GOOGLE_ANALYTICS_4,
  NODE_ENV
} from '@/utilities/constants.js';

require('../node_modules/video.js/dist/video-js.min.css');
require('../node_modules/shepherd.js/dist/css/shepherd.css');

store.dispatch('getBrand');

if (NODE_ENV === 'production') {
  Vue.use(
    VueGtag,
    {
      config: { id: VUE_APP_GOOGLE_ANALYTICS_4 },
      bootstrap: false
    },
    router
  );

  Vue.use(Meta);
}

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdiSvg'
});

Vue.use(VueGoogleMaps, {
  load: {
    key: VUE_APP_GOOGLE_API_KEY,
    libraries: 'places'
  }
});

Vue.use(VueSocialSharing);

Vue.config.productionTip = false;

export const app = new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
